import React, { useMemo } from 'react';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import {
  ConnectComponentsProvider,
  ConnectPayments,
  ConnectPayouts,
  ConnectBalances,
} from '@stripe/react-connect-js';
import { Box, Typography } from '@mui/material';
import { apiBaseUrl } from '../utils/Api/Api';

const ProviderStripeMiniDashboard = ({ providerId }) => {
  const connectInstance = useMemo(() => {
    const isDevelopment = window.location.href.includes('localhost');
    const publishableKey = isDevelopment
      ? 'pk_test_51I6PYnHj1UkrSfve8SN2ABn7G98QGSXyOCbK1clkWWJadfvNOUSwa2EFlOq8qI8zAfvDrLseZoSWHq6Sr53OI2F4002aZJBqY8'
      : 'pk_live_51I6PYnHj1UkrSfvewIg6geHEeEYhjrQDjEQzDIHpIS7IGWaxFmVfiwdeJcXCbb7dQUgj4D2zUncXdq4Lju6LlJYE00q2qS9Vsn';

    return loadConnectAndInitialize({
      publishableKey,
      fetchClientSecret: async () => {
        const resp = await fetch(`${apiBaseUrl}providers/${providerId}/stripe_account_session.json`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-User-Email': JSON.parse(localStorage.getItem('current_user'))?.email || '',
            'X-User-Token': JSON.parse(localStorage.getItem('current_user'))?.authentication_token || '',
          },
        });
        const json = await resp.json();
        if (!resp.ok) {
          throw new Error(json?.errors?.[0] || 'Não foi possível iniciar sessão Stripe.');
        }
        return json.client_secret;
      },
      appearance: {
        variables: {
          colorPrimary: '#F8963E',
        },
      },
    });
  }, [providerId]);

  return (
    <ConnectComponentsProvider connectInstance={connectInstance}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box>
          <Typography variant="pageTitle">
            Financeiro (Stripe)
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Pagamentos, saldo e repasses sem sair do app.
          </Typography>
        </Box>

        <Box sx={{ width: '100%', overflow: 'hidden' }}>
          <ConnectBalances />
        </Box>
        <Box sx={{ width: '100%', overflow: 'hidden' }}>
          <ConnectPayouts />
        </Box>
        <Box sx={{ width: '100%', overflow: 'hidden' }}>
          <ConnectPayments />
        </Box>
      </Box>
    </ConnectComponentsProvider>
  );
};

export default ProviderStripeMiniDashboard;

